import React from 'react'
import PromocionesComp from '../components/promociones/promocionescomp'


const Promociones = () => {
  return (
    <>
    <PromocionesComp/>
    
    </>
  )
}

export default Promociones